import React from 'react';

import { css } from '@emotion/css';
import { Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useKeycloak } from '@/auth/KeycloakAuthState.ts';
import { MenuActionTooltip } from '@/components/floating/MenuTooltip.tsx';
import { UserPicture } from '@/components/user-picture/UserPicture';
import { useStyles } from '@/hooks/useStyles';
import { Queries } from '@/queries/Queries';

export const UserMenu: React.FC = ({}) => {
  const styles = useStyles(makeStyles);
  const user = Queries.user.useMe({});
  const { t } = useTranslation();
  const keycloak = useKeycloak(state => state.keycloak);

  if (user.userType === 'admin') {
    return (
      <div id="user-account-menu" className={styles.picture}>
        <UserPicture />
      </div>
    );
  }
  return (
    <MenuActionTooltip
      openOnHover
      placement="right-end"
      actions={[
        <Link id="nav-account" to="/account" key="account">
          {t('pages.account.title')}
        </Link>,
        <Typography
          id="disconnect-button"
          variant="body"
          onClick={() => keycloak.logout({ redirectUri: window.origin })}
          key="disconnect"
        >
          {t('navbar.disconnect')}
        </Typography>,
      ]}
    >
      <div id="user-account-menu" className={styles.picture}>
        <UserPicture givenName={user.firstName} familyName={user.lastName} />
      </div>
    </MenuActionTooltip>
  );
};

const makeStyles = () => ({
  picture: css`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    height: 100%;
  `,
});
